import React from 'react';
import { withGoogleMap, GoogleMap, Marker } from "react-google-maps";

export default withGoogleMap(props => (
  <GoogleMap
    ref={props.onMapLoad}
    defaultZoom={15}
    defaultCenter={{ lat: 3.121109, lng: 101.6769496 }}
    onClick={props.onMapClick}
  >
    {props.markers.map((marker, index) => (
      <Marker
        {...marker}
        onRightClick={() => props.onMarkerRightClick(index)}
      />
    ))}
  </GoogleMap>
));



// WEBPACK FOOTER //
// ./src/screens/Map.js